module.exports = __webpack_public_path__ + "assets/docs/Folleteria.d1136844.pdf";